import { useState } from "react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";

export function ForgotPassword({ tenantSlug, accentStyle }) {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [link, setLink] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async () => {
    if (!email) { toast.error("Enter your email"); return; }
    setLoading(true); setLink("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email: email.trim(), ...(tenantSlug ? { tenant_slug: tenantSlug } : {}) });
      if (data.reset_link) { setLink(data.reset_link); toast.success("Reset link ready"); }
      else toast.success(data.message || "Reset link sent to your email");
    } catch (e) { toast.error(apiErr(e)); } finally { setLoading(false); }
  };
  if (!open) return (
    <button type="button" onClick={() => setOpen(true)} className="text-xs text-slate-400 hover:text-slate-200" data-testid="forgot-password-link">Forgot password?</button>
  );
  return (
    <div className="mt-3 rounded-lg border border-slate-800 bg-slate-900/40 p-3" data-testid="forgot-password-box">
      <p className="text-xs text-slate-400">Enter your account email to get a reset link.</p>
      <div className="mt-2 flex gap-2">
        <input className="tf-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" data-testid="forgot-email" />
        <button type="button" onClick={submit} disabled={loading} className="shrink-0 rounded-lg px-3 text-sm font-medium text-white disabled:opacity-60" style={accentStyle || { background: "#10b981" }} data-testid="forgot-submit">{loading ? "…" : "Send"}</button>
      </div>
      {link && (
        <div className="mt-2">
          <p className="text-[11px] text-amber-400">Email not configured — use this link:</p>
          <a href={link} className="break-all text-[11px] text-emerald-300 underline" data-testid="forgot-reset-link">{link}</a>
        </div>
      )}
      <button type="button" onClick={() => setOpen(false)} className="mt-2 text-[11px] text-slate-500 hover:text-slate-300">Cancel</button>
    </div>
  );
}
